import SchoolIcon from "@material-ui/icons/School";
import { useState } from "react";
import InfoWindow from "./InfoWindow";
import Tooltip from "@material-ui/core/Tooltip";

interface IMarker {
  lat: number;
  lng: number;
  isSchool?: boolean;
  isSelected?: boolean;
  resource: any;
  sendToParent?: any;
  isSidePanelOpen?: boolean;
  color?: string;
  name?: string;
}

interface ISvg {
  color: string;
}

const CustomSvgMarkerIcon = ({color}: ISvg) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37}
    height={37}
    fill="none"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M18.5 37C13.875 32.89 4.625 19.146 4.625 12.333c0-3.271 1.462-6.408 4.064-8.72C11.29 1.3 14.819 0 18.5 0c3.68 0 7.21 1.3 9.811 3.612 2.602 2.313 4.064 5.45 4.064 8.721 0 6.813-9.25 20.556-13.875 24.667Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M18.5 20.813a5.781 5.781 0 1 0 0-11.563 5.781 5.781 0 0 0 0 11.563Z"
    />
  </svg>
)

const Marker = ({
  isSchool,
  isSelected,
  resource,
  sendToParent,
  isSidePanelOpen,
  color,
  name
}: IMarker) => {
  const [isOpenInfoWindow, setIsOpenInfoWindow] = useState<boolean>(false);
  const selectedColor = color ? color : "#2f51bd";

  return (
    <Tooltip
      title={name ? name : ""}
      placement="top"
      arrow={true}
      disableHoverListener={!isSelected}
    >
      <div
        style={{
          position: "absolute",
          top: "-30px",
          left: "-17px",
          cursor: "pointer",
        }}
        onClick={() => setIsOpenInfoWindow((value) => !value)}
      >
        {isSchool ? (
          <SchoolIcon
            fontSize="large"
            style={{
              fill: "#2F4DB9",
            }}
          />
        ) : (
          <CustomSvgMarkerIcon color={isSelected ? selectedColor : "#b22424"} />
        )}

        {isOpenInfoWindow && (
          <InfoWindow
            data={resource}
            isSchool={isSchool}
            isSelected={isSelected}
            isSidePanelOpen={isSidePanelOpen}
            infoWindowCallback={(postalCode: string) => sendToParent(postalCode)}
          />
        )}
      </div>
    </Tooltip>
  );
};

export default Marker;
